/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AITranslate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.81 11.363c-.422 0-.74-.107-.956-.322-.206-.216-.331-.498-.376-.848H4.41a1.777 1.777 0 0 1-.74.982c-.35.233-.798.35-1.345.35-.708 0-1.273-.184-1.694-.552C.211 10.598 0 10.082 0 9.428c0-.672.247-1.183.74-1.533.502-.358 1.268-.538 2.299-.538H4.37v-.538c0-.94-.497-1.412-1.492-1.412-.449 0-.812.09-1.09.27-.277.17-.51.398-.699.685l-.874-.713c.197-.376.53-.699.995-.968.466-.278 1.067-.417 1.802-.417.879 0 1.569.211 2.071.632.502.422.753 1.031.753 1.83v3.482h.874v1.156h-.9Zm-3.067-.914c.475 0 .865-.107 1.17-.323.305-.215.457-.493.457-.833V8.284H3.066c-1.058 0-1.587.318-1.587.955v.269c0 .314.112.551.336.712.224.153.534.229.928.229ZM10.217 3.483h5.064v1.185h-5.064V3.483Zm.01 2.42h5.104v1.155h-5.104V5.903Zm-.05 2.4h5.084V9.48h-5.085V8.304Zm-.79-4.82h1.245v3.352c0 1.762-.274 4.244-1.985 5.682-.183-.253-.679-.709-.942-.87 1.54-1.308 1.681-3.262 1.681-4.812V3.483Zm5.327 0H16v7.495c0 .719-.172 1.083-.638 1.286-.486.213-1.205.233-2.259.233a4.6 4.6 0 0 0-.506-1.276c.719.04 1.56.03 1.803.03.233-.01.314-.08.314-.294V3.483Z" /></svg>;
}
;